import { render, staticRenderFns } from "./BuildHeaderActions.vue?vue&type=template&id=2fb696c5"
import script from "./BuildHeaderActions.vue?vue&type=script&lang=js"
export * from "./BuildHeaderActions.vue?vue&type=script&lang=js"
import style0 from "./BuildHeaderActions.vue?vue&type=style&index=0&id=2fb696c5&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports